import React, { useEffect, useState } from 'react';
import { Table, Button, notification, Col, Dropdown, Form, Input, Row, Space, Tooltip } from 'antd';
import API_SERVICE from 'shared/services/api-service';
import { RootState } from "shared/redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  setBulkLoginPageNo,
  setBulkLoginPageSize,
  setBulkLoginResetFilterData,
  setBulkLoginIsShowFilter,
  setBulkLoginLeadSearchParam,
 } from "shared/redux/bulkLogin-reducer";
 import {
  setBulkLoginUploadPageNo,
  setBulkLoginUploadPageSize,
  setBulkLoginUploadSearchParam,
 } from "shared/redux/bulkLoginUpload-reducer";

import { useHistory,useLocation } from 'react-router-dom';
import { debounce } from 'lodash';
import { FaSearch } from 'react-icons/fa';
import blackFilterIcon from "../../../assets/images/blackFilter.svg";
import blackRefereshIcon from "../../../assets/images/blackReferesh.svg";
import { hasUserRole, numberWithCommas, saveByteArray } from "shared/services/Utility";
import LeadFilter from 'shared/components/Lead/LeadFilter/LeadFilter';
import { setScreenHeader } from "shared/redux/common-reducer";

interface LocationState {
  uploadId?: string;
}

const BulkLoginTable: React.FC<{ setActiveStepKey: any }> = ({ setActiveStepKey }) => {
  const [bulkLoginLeadData, setBulkLoginLeadData] = useState([]);
  const [loading, setLoading] = useState(false);
  const userRolePermission = hasUserRole();
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const bulkLoginLead: any = useSelector((state: RootState) => state.bulkLoginLead);
  const bulkLoginUpload: any = useSelector((state: RootState) => state.bulkLoginUpload);
  const dispatch = useDispatch();
  const history = useHistory();  
  const [bulkLoginForm] = Form.useForm();
  const { appColors, isMobile }: any = useSelector(
    (state: RootState) => state.common
  );
  const customStyles: any = { "--bgColor": appColors?.appPrimaryColor ?? "" };
  const btnPrimaryStyles: any = {"--btnColor": appColors?.appPrimaryColor ?? ""}
  const btnDefaultBorderStyle: any = {'--borderColor': appColors?.appSecondaryColor ?? ""};
  const location = useLocation<LocationState>();
  const uploadedId = location.state?.uploadId;

  useEffect(() => {
    dispatch(
      setScreenHeader({
        backScreenTitle: "Lead",
        backScreenPath: "/lead",
        screenTitle: "Bulk Login",
      })
    );
    dispatch(setBulkLoginUploadPageNo(1))
    dispatch(setBulkLoginPageSize(10))
    dispatch(setBulkLoginPageNo(1))
    dispatch(setBulkLoginUploadPageSize(10))
    if (uploadedId)
    {
      getBulkLoginDataForID(bulkLoginUpload.pageNo, bulkLoginUpload.pageSize, bulkLoginUpload.searchParam);
    }
    else{
      getBulkLoginData(bulkLoginLead.pageNo, bulkLoginLead.pageSize, bulkLoginLead.searchParam, bulkLoginLead.filterData);
    }      
  }, [bulkLoginLead.searchParam,
    bulkLoginLead.filterData,
    bulkLoginUpload.searchParam
  ]);

  const getBulkLoginDataForID = (
        pageNo:number = 1,
        pageSize:number = 10,
        searchParam:any=null,
       
      ) => {
      let params = {};
      params = {
          bulkUploadId:uploadedId,
         searchParam: searchParam,
      };
      setLoading(true);
      setBulkLoginLeadData([]);
      API_SERVICE.getLeadsByUploadedId(pageNo, pageSize, params)
        .then(({ data }) => {
          const hasData = data?.payload?.content?.length > 0;
          if (!hasData) {
            notification.error({ message: "No data found." });
          }
         setBulkLoginLeadData(data?.payload?.content)
         setTotalRecords(data?.payload?.totalElements);
        })
        .catch((error) => {
          notification.error({ message: API_SERVICE.handleErrors(error) });
        })
        .finally(() => setLoading(false));
    };

    const getBulkLoginData = (
      pageNo:number = 1,
      pageSize:number = 10,
      searchParam:any=null,
      filterData:any = bulkLoginLead.filterData
    ) => {
      let params = {};
    params = {
      ...filterData,
      searchParam: searchParam,
    };
    setLoading(true);
    setBulkLoginLeadData([]);
    API_SERVICE.getLeadsByFilter(pageNo, pageSize,"LIST_LEADS", params)
      .then(({ data }) => {
        const hasData = data?.payload?.content?.length > 0;
        if (!hasData) {
          notification.error({ message: "No data found." });
        }
       setBulkLoginLeadData(data?.payload?.content)
       setTotalRecords(data?.payload?.totalElements);
      })
      .catch((error) => {
        notification.error({ message: API_SERVICE.handleErrors(error) });
      })
      .finally(() => setLoading(false));
    
   
  };

  const columns = [
    { 
      title: 'DC Case ID', 
      dataIndex: 'caseId', 
      key: 'caseId', 
      render: (caseId: string, record: any) => (
        <a 
          onClick={() => history.push(`/lead/details/${caseId}`)}
          style={{ color: "#1890ff", textDecoration: "underline", cursor: "pointer" }}
        >
          {caseId}
        </a>
      ),
    },
    {
      title:"Lead",
      dataIndex: ["contactDetails", "firstName"],
      key: "name",
      width: 50,
      ellipsis: true,
      render: (_: any, record: any) => {
        const leadNames = record?.contactDetails?.firstName;
            if ((leadNames?.length ?? 0) > 0) {
            return (
              <div style={{ width: "200px", whiteSpace: "pre-line" }}>
                <text>{leadNames}</text>
              </div>
            );
          }
        }
      },
    {
      title: "Product Type",
      dataIndex: ["loanType"],
      key: "productType",
      ellipsis: true,
    },
    { 
      title: 'Applicant SubType', 
      dataIndex: 'applicantSubType', 
      key: 'applicantSubType' 
    },
    {
      title: "Lead Originator",
      dataIndex: ["leadOriginatorDetails", "companyName"],
      key: "leadOriginator",
      render: (_: any, record: any) => {
        let value = uploadedId 
          ? record?.leadOriginator 
          : record?.leadOriginatorDetails?.companyName 
          return value ? <span>{value}</span> : null;
      }
    },
    { 
      title: 'Requested Loan Amount', 
      dataIndex: 'requestedLoanAmount', 
      key: 'requestedLoanAmount',
      render: (_: any, record: any) => {
        let value = uploadedId 
          ? record.loanDetails?.loanAmount 
          : record.requestedLoanAmount;    
        return value ? <span>Rs. {numberWithCommas(value)}</span> : null;
      }
    },
    { 
      title: 'Pincode', 
      dataIndex: 'pinCode',
      key: 'pinCode' 
    },
    {
      title: "Lender Name",
      dataIndex: ["lenderProposalDTO", "allLenderNames"],
      key: "allLenderNames",
      ellipsis: true,
      render: (_: any, record: any) => {
        const lenderNames = record?.lenderProposalDTO?.allLenderNames;
          if ((lenderNames?.length ?? 0) > 0) {
            return (
              <div style={{ width: "200px", whiteSpace: "pre-wrap" }}>
                <text>{lenderNames}</text>
              </div>
            );
          }        
        return "-";
      },
    },
    {
      title: "Lender Current Stage",
      dataIndex: ["lenderProposalDTO", "allLenderStages"],
      key: "allLenderStages",
      ellipsis: true,
      render: (_: any, record: any) => {
        let lenderStage = record?.lenderProposalDTO?.allLenderStages;
        return (
          <div style={{ width: "200px", whiteSpace: "pre-wrap" }}>
            <text>{lenderStage ?? "-"}</text>
          </div>
        );
      },
    },
  ];

  const refreshLead = () => {
      dispatch(setBulkLoginResetFilterData());
      dispatch(setBulkLoginIsShowFilter(false));
      bulkLoginForm.setFieldsValue({ searchBox: "" });
      dispatch(setBulkLoginLeadSearchParam(""));
      dispatch(setBulkLoginPageNo(1));
    };
  

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record: any) => ({}),
    preserveSelectedRowKeys:true
  };

  const handleExport = () => {
    const payload = {
      caseIds : selectedRowKeys,
      excelColumnMappingEntity:"BULK_LEAD_LOGIN"
    }
    if(selectedRowKeys.length === 0){
      notification.error({message:"Select atleast one caseId to export"})
    }
    else{
      setLoading(true)
      API_SERVICE.loginLeadExport(payload)
      .then(({ data }) => {
        saveByteArray([data], "export_leads_login.xlsx")
        setSelectedRowKeys([])
      })
      .catch(async (e) => {
        const data = JSON.parse(await e.response.data.text());
        const message = data?.payload?.errorMessage ?? e;
        notification.error({ message: API_SERVICE.handleErrors(message) });
      })
      .finally(() => setLoading(false));
    }
    
  };

    const handlePaginationChange = (pagination) => {
      let page = !uploadedId ? (pagination.pageSize !== bulkLoginLead.pageSize ? 1 : pagination.current) : pagination.pageSize !== bulkLoginUpload.pageSize ? 1 : pagination.current;
        !uploadedId? dispatch(setBulkLoginPageNo(page)) : dispatch(setBulkLoginUploadPageNo(page));
        !uploadedId? dispatch(setBulkLoginPageSize(pagination.pageSize)):dispatch(setBulkLoginUploadPageSize(pagination.pageSize));
        if (uploadedId)
        {
          getBulkLoginDataForID(page, pagination.pageSize, bulkLoginUpload.searchParam);
        }
        else{
          getBulkLoginData(page, pagination.pageSize, bulkLoginLead.searchParam, bulkLoginLead.filterData);
        }      
      window.scrollTo(0, 0);
    };

  
    return (
      <div className="content-box">
        <Form form={bulkLoginForm} className='app-filter-bar'>
          <div className='app-filter-bar-left'>
            <Form.Item name="searchBox" style={{flex:1, marginBottom:"0px"}}>
              <Input
                size="large"
                className="search-box"
                placeholder="Search"
                onChange={debounce((event) => {
                  if (event?.target?.value?.length > 2) {
                    if(uploadedId){
                      dispatch(setBulkLoginUploadSearchParam(event.target.value));
                      dispatch(setBulkLoginUploadPageNo(1));
                    }
                    else{
                      dispatch(setBulkLoginLeadSearchParam(event.target.value));
                      dispatch(setBulkLoginPageNo(1));
                    }
                    
                  } else if (event?.target?.value?.length == 0) {
                    if(uploadedId){
                      dispatch(setBulkLoginUploadSearchParam(""))
                      dispatch(setBulkLoginUploadPageNo(1));
                    } 
                    else{
                      dispatch(setBulkLoginLeadSearchParam(""))
                      dispatch(setBulkLoginPageNo(1));
                    }
                  }
                }, 600)}
                allowClear
                prefix={<FaSearch />}
              />
            </Form.Item>
            {!uploadedId && (
              <>
                <Button
                  type="primary"
                  className="filter-btn"
                  onClick={() =>
                    dispatch(
                      setBulkLoginIsShowFilter(
                        !bulkLoginLead.bulkLoginIsShowFilter
                      )
                    )
                  }
                >
                  <img
                    src={blackFilterIcon}
                    alt=""
                  />
                  <div
                    className="badge-green"
                    hidden={
                      !(
                        bulkLoginLead.filterData?.connectorId ||
                        bulkLoginLead.filterData?.loanProductIds || 
                        bulkLoginLead.filterData?.location ||
                        bulkLoginLead.filterData?.managerHierarchy
                      )
                }
              />
                </Button>
  
                <Tooltip title="Refresh">
                  <Button
                    type="primary"
                    className="filter-btn"
                    onClick={() => refreshLead()}
                  >
                    <img
                      src={blackRefereshIcon}
                      alt=""
                    />
                  </Button>
                </Tooltip>
              </>
            )}
          </div>
          <div className='app-filter-bar-right'>
            {!uploadedId && (
              <>
                <Tooltip title="Click to download selected leads in an Excel format.">
                  <Button
                    type="primary"
                    className="dynamic-btn-primary"
                    style={btnPrimaryStyles}
                    onClick={() => handleExport()}
                  >
                    Export
                  </Button>
                </Tooltip>
                <Tooltip title="Upload the edited Excel file with lead details. Ensure all required fields are correctly filled before submitting.">
                  <Button
                    type="primary"
                    className="dynamic-btn-primary"
                    style={btnPrimaryStyles}
                    onClick={() => history.push("/lead/bulkLogin/import")}
                  >
                    Import
                  </Button>
                </Tooltip>
              </>
            )}
            <Button
              htmlType="button"
              className="dynamic-btn-default-back"
              style={btnDefaultBorderStyle}
              hidden={
                !(userRolePermission["CreateLead"] || userRolePermission["Admin"])
              }
              onClick={() => history.goBack()}
            >
              Back
            </Button>
          </div>
        </Form>
          {(bulkLoginLead.bulkLoginIsShowFilter && !uploadedId) && (
            <LeadFilter
              key="NEW_LEAD_FILTER"
              type="BULK_LOGIN"
            />
          )}
        <Table
          className="dynamic-pagination-checkbox1"
          style={customStyles}
          size="small"
          loading={loading}
          scroll={{ x: "max-content" }}
          dataSource={bulkLoginLeadData}
          columns={columns}
          rowKey={(record) => record?.caseId }
          rowClassName="selected-row"
          rowSelection={uploadedId ? undefined : rowSelection}
          pagination={{
            current: uploadedId? bulkLoginUpload.pageNo : bulkLoginLead.pageNo,
            pageSize: uploadedId? bulkLoginUpload.pageSize : bulkLoginLead.pageSize,
            total: totalRecords,
          }}
          onChange={handlePaginationChange}
        />
      </div>
    );
};

export default BulkLoginTable;